// extracted by mini-css-extract-plugin
export default {"cta":"AG-z","disabled":"BG-z"};